import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import {
  Button,
  Input,
  Modal,
  Select
} from 'antd';
import {
  notificationsAtom,
  addLeadLogAtom
} from '../../../../atoms/Atoms';
import api from '../../../../api/api';

function NewLeadNoteModal() {
  const { Option } = Select;
  const { t, i18n } = useTranslation();
  const [lead, setLead] = useRecoilState(addLeadLogAtom);
  const [note, setNote] = useState('');
  const [selectedType, setSelectedType] = useState(0);
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);

  function submit() {
    setLoading(true);
    api.post('leads/lead/logs', { LeadId: lead?.id, Message: note, Type: selectedType })
      .then((response) => {
        setLoading(false);
        if (response?.data?.error) {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        } else {
          setLead(null);
        }
      })
      .catch((error) => {
        setLoading(false);
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error.message,
            error: true,
          },
        ]);
      });
  }

  useEffect(() => {
    setNote('');
    setSelectedType(0);
  }, [lead]);

  return (
    <Modal
      title={t('new_note')}
      open={lead}
      onCancel={() => setLead(null)}
      footer={[
        <Button
          key="ok"
          type="primary"
          danger
          disabled={loading}
          onClick={() => setLead(null)}
        >
          {t('cancel')}
        </Button>,
        <Button
          key="ok"
          type="primary"
          disabled={note?.length === 0}
          loading={loading}
          onClick={() => submit()}
        >
          {t('add_note')}
        </Button>
      ]}
    >
      <div className="space-y-2">
        <Select
          className="w-full h-12"
          value={selectedType}
          disabled={loading}
          onChange={(obj) => setSelectedType(obj)}
        >
          <Option value={0}>{t('note')}</Option>
          <Option value={1}>{t('appointment')}</Option>
          <Option value={2}>{t('call')}</Option>
          <Option value={3}>{t('email')}</Option>
          <Option value={4}>{t('other')}</Option>
        </Select>
        <Input
          onChange={(obj) => setNote(obj.target.value)}
          value={note}
          disabled={loading}
        />
      </div>
    </Modal>
  );
}

export default NewLeadNoteModal;
